.ModalBody {
  border-radius: 5px;
  background: var(--overlay);
  padding: 40px !important;
}

.TitleModal {
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: var(--primary);
  display: flex;
  justify-content: center;
  align-items: center;
}

.DescriptionModal {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: var(--colori-neutri-gray);
  text-align: center;
  margin-top: 16px;
  width: 100%;
  padding-left: 32px;
  padding-right: 32px;
}

.OrderingItem {
  display: flex;
  height: 34px;
  padding: 8px 0px 8px 24px;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  border-radius: 5px;
  background: var(--colori-neutri-white);
  color: var(--primary-color, #118ab2);
  text-align: center;
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 8px;
  cursor: pointer;
}

.OrderingItemActive {
  background: var(--primary);
  color: var(--colori-neutri-white);
}

.ListOrderingItems {
  margin-top: 32px;
}

.ButtonConfirm {
  display: flex;
  padding: 8px;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 5px;
  background: var(--concorso);
  /* Shade Button Blu */
  box-shadow: 1px 1px 0px 0px var(--concorso-shadow);
  border: none;
  color: var(--colori-neutri-dark-gray);
  text-align: center;
  /* CTA */
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  transition: all 0.3s ease-in-out;
}
